exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wgt .wgt-action-image-content {\n  margin-top: 10px; }\n  .wgt .wgt-action-image-content img:hover {\n    cursor: pointer; }\n\n.wgt-action-image-content-img {\n  max-width: 100%;\n  max-height: 100%;\n  height: auto;\n  border-radius: 5px; }\n", ""]);

// exports
